import { createAction, props } from '@ngrx/store';
import { OnboardingOrderOutIntegration, OnboardingOrderOutIntegrationForm, OnboardingOrderOutIntegrationUpsert } from '@models/integrations/orderOut';
import { ResponseBadRequest } from '@interfaces/.';

export const INTEGRATION_FIND = createAction('[Integration] Find', props<{ id: string }>());
export const INTEGRATION_FIND_ALL = createAction('[Integration] Find All', props<{ storeId?: string | null }>());

export const INTEGRATION_FIND_SUCCESS = createAction('[Integration] Find Success', props<{ integration: OnboardingOrderOutIntegration }>());
export const INTEGRATION_FIND_ALL_SUCCESS = createAction('[Integration] Find All Success', props<{ integrationList: OnboardingOrderOutIntegration[] }>());
export const INTEGRATION_CREATED_SUCCESS = createAction('[Integration] Create Success', props<{ integration: OnboardingOrderOutIntegration | null }>());

export const INTEGRATION_FAILURE = createAction('[Integration] Failure', props<{ error: ResponseBadRequest }>());

export const INTEGRATION_UPDATE_LOADING = createAction('[Integration] Update Loading', props<{ loading: boolean }>());
export const INTEGRATION_UPDATE_FORM = createAction('[Integration] Update Form', props<{ integrationForm: OnboardingOrderOutIntegrationForm }>());
export const INTEGRATION_UPDATE_SELECTED = createAction('[Integration] Update Selected', props<{ integrationSelected: string[] }>());
export const INTEGRATION_EDIT_MODE = createAction('[Integration] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const INTEGRATION_UPDATE_ID = createAction('[Integration] Update Id', props<{ integrationId: string | null }>());

export const INTEGRATION_CREATE_VIEW = createAction('[Integration] Create View');
export const INTEGRATION_UPDATE_VIEW = createAction('[Integration] Update View', props<{ integrationId: string }>());

export const INTEGRATION_CREATE = createAction('[Integration] Create');
export const INTEGRATION_UPDATE = createAction('[Integration] Update');
export const INTEGRATION_REMOVE = createAction('[Integration] Remove', props<{ id: string }>());

export const INTEGRATION_CREATE_COMPLETED = createAction('[Integration] Create Completed');
export const INTEGRATION_UPDATE_COMPLETED = createAction('[Integration] Update Completed');
export const INTEGRATION_REMOVE_COMPLETED = createAction('[Integration] Remove Completed');
export const INTEGRATION_FIND_ALL_COMPLETED = createAction('[Integration] Find All Completed');

export const INTEGRATION_RESET = createAction('[Integration] Reset');
export const INTEGRATION_RESET_FORM = createAction('[Integration] Reset Form');
export const INTEGRATION_RESET_ERROR = createAction('[Integration] Reset Error');
export const INTEGRATION_CLEAR_STATE = createAction('[Integration] Clear State');
